import { DefinitionInfoElement } from '../../../types';

export const serializeDefinitionInfo = (node: DefinitionInfoElement): string => {
  const titleRender = `<div class="definition-info__title">${node.title}</div>`;
  const textRender = `<div class="definition-info__text">${node.definition}</div>`;
  const containerRender = `<div class="definition-info__container">${titleRender}${textRender}</div>`;

  return `<div class="definition-info" data-title="${node.title}" data-definition="${node.definition}">${containerRender}</div>`;
};
